import { inject, Injectable } from '@angular/core';
import { EngagementContactInteractionForm } from '@interfaces';
import { FuncService } from '../../../../services';

@Injectable({
	providedIn: 'root'
})
export class EngagementInteractionFormService {

	private func = inject(FuncService);

	public async addEngagementContactInteraction(payload: EngagementContactInteractionForm) {
		const engagementContactId = await this.func.engagement.interaction.add(payload);
		return engagementContactId;
	}

	public async updateEngagementContactInteraction(payload: EngagementContactInteractionForm) {
		const engagementContactId = await this.func.engagement.interaction.update(payload);
		return engagementContactId;
	}

	public async getInteractionById(engagementContactId: number, engagementId: number) {
		return await this.func.engagement.interaction.get({ engagementContactId, engagementId });
	}

}